export function usePostMessage() {
  const postMessage = (data) => {
    window.parent.postMessage(data, { targetOrigin: 'https://www.pitch.social/' });
  }
  return {
    postMessage,
  }
}
